// src/plugins/mobile-device-detect.js
export default {
  install(Vue) {
    Vue.prototype.$isMobileDevice = function () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iphone|ipad|ipod|blackberry|windows phone/i.test(
        userAgent
      );
    };
  },
};
